import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Label,
  FormFeedback,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  ModalFooter,
  Spinner,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import UnitService from "../../../services/OrderingServices/UnitService";
import Select from "react-select";

// Validation Schema
const validationSchema = Yup.object().shape({
  fromUnitId: Yup.number().required("From unit is required"),
  toUnitId: Yup.number().required("To unit is required"),
  conversionFactor: Yup.string()
    .matches(/^\d+(\.\d{1,2})?$/, "Only up to two decimal places allowed")
    .required("Conversion factor is required"),
  description: Yup.string(),
});

const UnitConversionForm = ({
  selectedItem,
  modal,
  toggleModal,
  fetchUnitConversion,
}) => {
  const [loading, setLoading] = useState(false);
  const [unitData, setUnitData] = useState([]);
  const fetchUnit = async () => {
    try {
      const response = await UnitService.getList();
      // Convert API data into select options
      const formattedUnits = response.map((unit) => ({
        value: unit.id,
        label: unit.name,
        ...unit, // keep other info if needed
      }));
      setUnitData(formattedUnits);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUnit();
  }, [selectedItem?.id]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedItem?.id || null,
      fromUnitId: selectedItem?.fromUnitId || null,
      toUnitId: selectedItem?.toUnitId || null,
      conversionFactor: selectedItem?.conversionFactor || null,
      description: selectedItem?.description || "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);

        if (values.id) {
          await UnitService.updateConversion(values.id, values);
          toast.success("Unit conversion updated successfully.");
        } else {
          await UnitService.createConversion(values);
          toast.success("New unit conversion is added successfully");
          resetForm();
        }
        fetchUnitConversion();
        toggleModal();
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data);
      } finally {
        setLoading(false);
      }
    },
  });

  const selectedFromUnit = unitData.find(
    (option) => option.value === formik.values.fromUnitId,
  );
  const selectedToUnit = unitData.find(
    (option) => option.value === formik.values.toUnitId,
  );
  const handleFromUnitChange = (selectedOption) => {
    formik.setFieldValue("fromUnitId", selectedOption?.value || null);
  };

  const handleToUnitChange = (selectedOption) => {
    formik.setFieldValue("toUnitId", selectedOption?.value || null);
  };

  // Reset form when modal closes
  useEffect(() => {
    if (!modal) {
      formik.resetForm();
    }
  }, [modal]);
  return (
    <Offcanvas isOpen={modal} toggle={toggleModal} backdropClassName="bg-dark bg-opacity-50" direction="end"
      className="shadow-lg animate__animated animate__slideInRight bg-white ">
      <OffcanvasHeader toggle={toggleModal}>
        {selectedItem?.id ? "Update" : "Add"} Unit Conversion
      </OffcanvasHeader>
      <OffcanvasBody>

      <Form onSubmit={formik.handleSubmit}>
       
          <Row className="flex flex-col">
            
              <div className="mb-3">
                <Select
                  id="fromUnitId"
                  name="fromUnitId"
                  options={unitData}
                  value={selectedFromUnit || null}
                  onChange={handleFromUnitChange}
                  placeholder="Select From Unit"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (baseStyles) => ({
                      ...baseStyles,
                      padding: "0.3rem",
                    }),
                  }}
                />
                {formik.touched.fromUnitId && formik.errors.fromUnitId && (
                  <div className="text-danger">{formik.errors.fromUnitId}</div>
                )}
              </div>
          

           
              <div className="mb-3">
                <Select
                  id="toUnitId"
                  name="toUnitId"
                  options={unitData}
                  value={selectedToUnit || null}
                  onChange={handleToUnitChange}
                  placeholder="Select To Unit"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (baseStyles) => ({
                      ...baseStyles,
                      padding: "0.3rem",
                    }),
                  }}
                />
                {formik.touched.toUnitId && formik.errors.toUnitId && (
                  <div className="text-danger">{formik.errors.toUnitId}</div>
                )}
              </div>
            
            
              <div className="form-floating mb-3">
                <Input
                  id="conversionFactor"
                  name="conversionFactor"
                  type="text"
                  className="form-control"
                  placeholder="Enter unit conversionFactor"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.conversionFactor}
                  invalid={
                    !!(
                      formik.touched.conversionFactor &&
                      formik.errors.conversionFactor
                    )
                  }
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="conversionFactor" className="px-4">Conversion Factor </Label>
                {formik.touched.conversionFactor &&
                  formik.errors.conversionFactor && (
                    <FormFeedback type="invalid">
                      {formik.errors.conversionFactor}
                    </FormFeedback>
                  )}
              </div>
            
            
              {/* <div className="form-floating mb-3"> */}
              <div className="px-2.5">

              <textarea
                id="description"
                name="description"
                className={`form-control ${formik.touched.description && formik.errors.description
                    ? "is-invalid"
                    : ""
                  }`}
                placeholder="Enter description"
                rows={5}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description}
                style={{ padding: "1rem" }} // optional styling
              />
              </div>

              {formik.touched.description && formik.errors.description && (
                <div className="invalid-feedback">
                  {formik.errors.description}
                </div>
              )}
              {/* </div> */}
            
          </Row>
        
        
            <div className="d-flex bg-white align-content-center align-items-center justify-content-between gap-2 position-absolute bottom-0 start-0 end-0 p-3 ">
                                <button className="btn btn-danger w-100 " onClick={toggleModal}>
                                  Cancel
                                </button>
                    
                                <Button
                                  color="success"
                                  type="submit"
                                  disabled={loading}
                                  className="w-100"
                                >
                                  {loading && <Spinner size="sm" className="me-2" />}
                                  {loading
                                    ? selectedItem?.id
                                      ? "Updating..."
                                      : "Creating..."
                                    : selectedItem?.id
                                    ? "Update"
                                    : "Create"}
                                </Button>
                              </div>
        
      </Form>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default UnitConversionForm;
